export interface Particle {
  x: number;
  y: number;
  vx: number;
  vy: number;
  life: number;
  maxLife: number;
  color: string;
  size: number;
}

export class ParticlePool {
  private pool: Particle[] = [];
  active: Particle[] = [];

  burst(x: number, y: number, color: string, count = 12, speed = 80): void {
    for (let i = 0; i < count; i++) {
      const angle = (Math.PI * 2 * i) / count + Math.random() * 0.4;
      const sp = speed * (0.5 + Math.random() * 0.5);
      this.spawn({
        x,
        y,
        vx: Math.cos(angle) * sp,
        vy: Math.sin(angle) * sp,
        life: 0.4 + Math.random() * 0.3,
        maxLife: 0.7,
        color,
        size: 2 + Math.random() * 2,
      });
    }
  }

  sparkLine(x1: number, y1: number, x2: number, y2: number, color: string): void {
    const mx = (x1 + x2) / 2;
    const my = (y1 + y2) / 2;
    this.burst(mx, my, color, 6, 40);
  }

  private spawn(p: Particle): void {
    const particle = this.pool.pop() ?? { ...p };
    Object.assign(particle, p);
    particle.maxLife = p.life;
    this.active.push(particle);
  }

  update(dt: number): void {
    for (let i = this.active.length - 1; i >= 0; i--) {
      const p = this.active[i]!;
      p.life -= dt;
      if (p.life <= 0) {
        this.pool.push(p);
        this.active.splice(i, 1);
        continue;
      }
      p.x += p.vx * dt;
      p.y += p.vy * dt;
      p.vy += 120 * dt;
    }
  }

  draw(ctx: CanvasRenderingContext2D): void {
    for (const p of this.active) {
      const t = p.life / p.maxLife;
      ctx.globalAlpha = t;
      ctx.fillStyle = p.color;
      ctx.beginPath();
      ctx.arc(p.x, p.y, p.size * t, 0, Math.PI * 2);
      ctx.fill();
    }
    ctx.globalAlpha = 1;
  }
}
